<template>
    <div class="ops">
        <h1>Ops</h1>
    </div>
</template>

<script lang="ts" setup></script>
